// Tree-shaken ECharts: register only the chart types and components we use (smaller bundle).
import * as echarts from "echarts/core";
import { BarChart, CustomChart, LineChart, PieChart, ScatterChart } from "echarts/charts";
import { GridComponent, LegendComponent, MarkLineComponent, TitleComponent, TooltipComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([LineChart, BarChart, PieChart, ScatterChart, CustomChart, GridComponent, TooltipComponent, LegendComponent, MarkLineComponent, TitleComponent, CanvasRenderer]);

export { echarts };
